import { iconMap, SocialLinksProps } from '@/types/global.types';

const SocialLinks = ({ className, social = [] }: SocialLinksProps) => {
    // Function to format WhatsApp link to open directly
    const formatWhatsAppLink = (link: string): string => {
        if (!link) return '#';

        if (link.includes('wa.me/') || link.includes('api.whatsapp.com') || link.includes('web.whatsapp.com')) {
            return link;
        }
        let phoneNumber = link.replace(/[^\d+]/g, '');

        if (phoneNumber.startsWith('+')) {
            phoneNumber = phoneNumber.substring(1);
        }

        if (phoneNumber.length < 10) {
            return link;
        }

        return `https://wa.me/${phoneNumber}`;
    };

    return (
        <ul
            className={`grid gap-5 items-center justify-items-center ${className}`}
            style={{
                gridTemplateColumns: 'repeat(5, 1fr)',
               
                maxWidth: '100%',
            }}
        >
            {social.map((item, index) => {
                const IconComponent = iconMap[item.name.toLowerCase()];
                if (!IconComponent) return null;

                const isWhatsApp = item.name.toLowerCase() === 'whatsapp';
                const href = isWhatsApp ? formatWhatsAppLink(item.link) : item.link;

                return (
                    <li key={index}>
                        <a href={href} target="_blank" rel="noreferrer">
                            <IconComponent
                                className={`w-fit ${
                                    item.name.toLowerCase() === 'youtube'
                                        ? 'lg:h-[45px] h-9 mb-[-3px]'
                                        : item.name.toLowerCase() === 'whatsapp'
                                          ? 'lg:h-[45px] h-9 mb-[-3px]'
                                          : 'lg:h-8 md:h-7 h-6'
                                } dark:text-Grey20 text-bg-logo`}
                            />
                        </a>
                    </li>
                );
            })}
        </ul>
    );
};

export default SocialLinks;
